import { render, staticRenderFns } from "./CadastroEtiqueta.vue?vue&type=template&id=32f834b0"
import script from "./CadastroEtiqueta.vue?vue&type=script&lang=js"
export * from "./CadastroEtiqueta.vue?vue&type=script&lang=js"
import style0 from "./CadastroEtiqueta.vue?vue&type=style&index=0&id=32f834b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports